// 实现描点跳转
export function goAnchorModel(obj) {
  if (obj.$route.params.anchorItem) {
    const anchorId = obj.$route.params.anchorItem.anchorId
    if (obj.$route.path !== '/home') {
      if (anchorId) {
        obj.$nextTick(() => {
          obj.$bus.$emit("goAnchor", anchorId)
        })
      }
    }
  }
}